import { HugeiconsIcon } from "@hugeicons/react";
import {
  EarthIcon,
  BedIcon,
  BathtubIcon
} from "@hugeicons-pro/core-stroke-rounded";
import { PreviewFrame } from "./PreviewFrame";
import listingHouse from "../assets/listing-house.jpg";

export const SyndicationPreview = () => (
  <PreviewFrame noInnerCard>
    <div className="absolute inset-0 flex flex-col items-center justify-center pt-8">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white shadow-md">
        <HugeiconsIcon
          icon={EarthIcon}
          size={26}
          strokeWidth={1.5}
          className="text-primary-500"
        />
      </div>
      <div className="my-1 h-5 w-px border-l-2 border-dotted border-white/70" />

      <div
        className="flex w-[220px] flex-col overflow-hidden rounded-lg bg-white"
        style={{
          boxShadow:
            "0px 12px 16px -4px rgba(28,29,34,0.08), 0px 4px 6px -2px rgba(28,29,34,0.03)"
        }}
      >
        <img
          src={listingHouse}
          alt=""
          className="h-[88px] w-full object-cover"
        />
        <div className="flex flex-col gap-1 p-3">
          <span className="text-[15px] font-bold leading-5 text-content-1000">
            $2,375
          </span>
          <span className="text-[11px] font-medium leading-4 text-content-400">
            123 Maple Ave, Springfield, IL 62704
          </span>
          <div className="mt-1 flex items-center gap-3 text-[11px] font-medium text-content-400">
            <span className="flex items-center gap-1">
              <HugeiconsIcon icon={BathtubIcon} size={12} strokeWidth={1.5} />2
              baths
            </span>
            <span className="flex items-center gap-1">
              <HugeiconsIcon icon={BedIcon} size={12} strokeWidth={1.5} />2 beds
            </span>
          </div>
        </div>
      </div>
    </div>
  </PreviewFrame>
);
